import { EVENTS } from './core/constants';
import { legacyGetters } from './params/legacy';
import { metaAdapter } from './params/adapters/meta';
import { decoAdapter } from './params/adapters/deco';
import { reservaAdapter } from './params/adapters/reserva';
import { headlessAdapter } from './params/adapters/headless';
import { pickupAdapter } from './params/adapters/pickup';
import { orderFormAdapter } from './params/adapters/orderForm';
import type { EventName, EventContext, AdapterPayload, InitialConfig } from './types';

type GetterFn = (context: EventContext, config: InitialConfig) => unknown
type EventRequiredParams = { requiredParams: string[] } | undefined;

const adapters = {
  DECO: decoAdapter,
  RESERVA: reservaAdapter,
  HEADLESS: headlessAdapter,
  PICKUP: pickupAdapter,
  ORDERFORM: orderFormAdapter,
  META: metaAdapter,
} as const;

type AdapterKey = keyof typeof adapters

export async function getParameters(
  context: AdapterPayload,
  eventName: EventName,
  config: InitialConfig
) {
  const eventConfig = EVENTS[eventName] as unknown as EventRequiredParams;
  if (!eventConfig) return;

  const currentAdapter = context.adapter;
  const getters = adapters[currentAdapter as AdapterKey] ?? legacyGetters // fallback for legacy;

  const entries = await Promise.all(
    eventConfig.requiredParams.map(async (param) => {
      const getter = getters[param as keyof typeof getters] as GetterFn;

      if (typeof getter !== 'function') {
        console.error(`[DT] Missing getter "${param}" for adapter "${currentAdapter}"`);
        return [param, null] as const;
      }

      return [param, await getter(context, config)] as const;
    })
  );

  return Object.fromEntries(entries);
}